import { Component, OnInit, ViewChild } from "@angular/core";
import { AppService } from "app/services/app/app.service";
import { RestService } from "app/services/rest/rest.service";
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from "@angular/material/table";
import { MatAccordion } from '@angular/material/expansion';
import { Log } from "app/core/logging/log";

export interface User {
  username: string;
  name: string;
  roles: string;
}

@Component({
  selector: 'app-login-as',
  templateUrl: './login-as.component.html',
  styleUrls: ['./login-as.component.scss']
})
export class LoginAsComponent implements OnInit {

    @ViewChild(MatAccordion) accordion!: MatAccordion;
    isImpersonating = false;
    displayedColumns: string[] = ['username', 'actions'];
    dataSource = new MatTableDataSource<User>([]);

    constructor(private appService: AppService, private restService: RestService, private snack: MatSnackBar) {
        this.isImpersonating = this.appService.isImpersonating();
    }

    ngOnInit() {
        // Aquí deberías cargar los usuarios desde tu API
        /*
        const users: User[] = [
            { username: 'donmass31@gmail.com', name: 'donmass31', roles: 'USER' },
            { username: 'lorenabarea8@gmail.com', name: 'lorenabarea8', roles: 'USER' },
            { username: 'admin', name: 'Admin Root', roles: 'ADMIN' }
        ];
        this.dataSource.data = users;
        */
       Log.debug('isAdmin', {isAdmin: this.appService.isAdmin()})
        if(this.appService.isAdmin()){
            
            this.searchUsers();
        }
        
    }
    
    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
        this.dataSource.filter = filterValue;
        Log.debug("applyFilter", {event});
    }

    loginAs(username: string) {
        this.restService.loginAs(username).subscribe((result) => {
            this.appService.saveOriginalToken();
            this.appService.showSuccessToast('Bienvenido');
            this.appService.setToken(result.token);
            this.snack.open(`Ahora estás actuando como ${username}`, 'Cerrar', { duration: 3000 });
            setTimeout(()=> location.reload(), 1000);
        });
    }


    getProfile(){
        this.restService.getProfile().subscribe(result => {
            if(result.id !=null && result.id != 0){
                this.appService.usuario = result;
            }
        });
    }

    searchUsers(){
        this.restService.searchUsers("").subscribe(result => {
            this.dataSource.data = result.content;
        });
    }


    stop() {
        this.appService.restoreOriginalToken();
        this.snack.open(`Has vuelto a tu sesión de administrador`, 'Cerrar', { duration: 3000 });
        setTimeout(()=> location.reload(), 1000);
    }

    get impersonatedUser(): string | null {
        return this.appService.usuario.username;
    }
}
